/*
 * Module for the action group mapping modal
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/shared/actionGroupMappingModal/actionGroupMappingModalView",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, $, Messenger, ActionGroupMappingModalView, SelectableListModule) {
  var ActionGroupMappingModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "actionGroupMappingModal";
      this.region = options.region;
      this.touchPointId = options.selectedTouchPoint;
      this.languageId = options.selectedLanguage;
      this.selectedActionGroup = null;
      this._setUpVents();
    },
    show: function (conversation) {
      this.conversation = conversation;
      this.groups = Messenger.reqres.request("action:groups");
      this.layout = new ActionGroupMappingModalView.actionGroupMappingModalLayout();
      this.actionGroupsList = this.addSubModule(
        new SelectableListModule({ region: this.layout.actionGroupsList }),
      );
      this.layout.on(
        "done",
        function () {
          if (this.selectedActionGroup !== null) {
            conversation.setActionGroup(
              this.touchPointId,
              this.languageId,
              this.selectedActionGroup,
            );
            Messenger.vent.trigger("close:modal");
          } else {
            //no action group selected, so show an error
            this.actionGroupError($.t("topic.responseProperties.actionGroupError"));
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.layout.on(
        "select",
        function (groupName) {
          var actionGroupObj = this.groups.findWhere({ name: groupName });
          if (actionGroupObj) {
            this.selectedActionGroup = actionGroupObj;
          }
          //this.selectedActionGroup = actionGroup;
          this.layout.trigger("done");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    clearError: function () {
      this.layout.clearError();
    },
    actionGroupError: function (errorMessage) {
      this.layout.actionGroupError(errorMessage);
    },
    _showSubViews: function () {
      //var groups = Messenger.reqres.request("action:groups");
      this.actionGroupsList.show(this.groups);
    },
    _setUpVents: function () {
      //handle when we select an action group
      Messenger.vent.on(
        "list:item:selected",
        function (model) {
          this.selectedActionGroup = model;
        },
        this,
      );
      //
      // //user selected action group via the typeahead search, so select the action group and close the modal
      // Messenger.vent.on("mapping:search:selected", function(model){
      //   this.selectedActionGroup = model;
      //   this.layout.trigger("done");
      // }, this);
    },
  });

  return ActionGroupMappingModalController;
});
